import React from 'react'

export const Pregnancyhistory = () => {
  return (
    <div>Pregnancyhistory</div>
    
  )
}
